import { Star } from "phosphor-react";
import React from "react";
import { Link } from "react-router-dom";

const Card = ({ data }) => {
  return (
    <>
      <Link to={`/${data.id}`}>
        <div className="relative overflow-hidden p-4 lg:w-[500px] rounded-[40px] h-[450px] bg-slate-100">
          <img
            className="rounded-[30px] object-cover h-full w-full"
            src={data.poster}
            alt=""
          />
          <div className="flex space-x-3 items-center absolute top-9 right-9 bg-white/50 backdrop-blur-md py-4 px-6 rounded-3xl">
            <span className="text-lg lg:text-2xl font-semibold text-slate-700">
              {data.imdb_rating}
            </span>
            <Star className="text-yellow-500" size={24} weight="fill" />
          </div>
          <div className="absolute p-10 bottom-0 left-0 bg-white/50 backdrop-blur-lg w-full z-20">
            <h1 className="text-xl lg:text-3xl text-slate-900 font-bold mb-1">
              {data.title}
            </h1>
            <div className="flex space-x-4 items-center">
              <p className="flex text-sm py-1 px-2 bg-green-500 rounded-full text-slate-900 font-medium">
                {data.genres[0]}
              </p>
              <div className="h-[6px] w-[6px] rounded-full bg-slate-600"></div>
              <p className="text-lg lg:text-xl text-slate-600 font-medium">
                {data.year}
              </p>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default Card;
